import store from '../../../app/store'
import vuex from 'vuex'
import vue from 'vue'
import seckill from './seckill'

vue.use(vuex)

let modules = [
  {
    name: 'huoliIOUSecKill',
    module: seckill
  }
]

modules.map(({name, module}) => {
  store.registerModule(name, module)
})

export default store



// WEBPACK FOOTER //
// ./src/projects/huoliIOUSecKill/store/index.js